import { Button, Layout, theme, Form, Input, notification, Spin } from "antd";
import PasswordStrengthBar from "react-password-strength-bar";

import React, { useState } from "react";
import "../CreateRole/CreateRole.css";

import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import UserApi from "../../common/Apis/UserApi";

const ChangeAccountPassword = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const [inputPassword, setInputPassword] = React.useState("");
  const [inputValuestart, setinputValuestart] = React.useState(true);
  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [loadings, setLoadings] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [btnDisable, setbtnDisable] = useState(true);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleChangePassword = (event) => {
    setInputPassword(event.target.value);
    if (event.target.value == "Weak" || event.target.value == "Too Short") {
      setbtnDisable(true);
    }
    setbtnDisable(
      event.target.value.length < 6 || !/[A-Z]/.test(event.target.value)
    );
    setinputValuestart(false);
  };

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      email: decodedToken.sub,
      oldPassword: data.oldPassword,
      newPassword: inputPassword,
    });
    // change Account Password Api

    UserApi.changeAccountPassword(formData)
      .then((response) => {
        notification.open({
          message: (
            <span style={{ fontWeight: "bold" }}>{response.resultStatus}</span>
          ),
          description: response.payload,
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        setTimeout(() => {
          return navigate("/dashboard");
        }, 2000);
        // return navigate("/login");
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const [Permissions, setPermissions] = useState([]);

  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="userRole"
            onFinish={handleSubmit}
          >
            <>
              <div className="col-lg-6">
                <Form.Item
                  name="oldPassword"
                  label="Enter old password"
                  className="text-lable"
                >
                  <Input.Password
                    placeholder="Old Password"
                    className="control-input"
                  />
                </Form.Item>{" "}
                <Form.Item
                  name="NewPassword"
                  label="Enter New Password"
                  className="text-lable"
                >
                  <Input.Password
                    placeholder="New Password"
                    className="control-input mb-2"
                    onChange={handleChangePassword}
                    type="password"
                    visibilityToggle={{
                      visible: passwordVisible,
                      onVisibleChange: setPasswordVisible,
                    }}
                  />

                  {inputPassword !== "" ? (
                    <>
                      <PasswordStrengthBar
                        className="password-progress"
                        password={inputPassword}
                        minLength={5}
                      />
                    </>
                  ) : (
                    <>
                      {inputValuestart === true ? (
                        <>
                          <p className="content-info ">
                            8 characters or longer. Combine upper and lowercase
                            letters and numbers.
                          </p>
                        </>
                      ) : (
                        <>
                          <p className="content-info " style={{ color: "red" }}>
                            Password must be min. 8 characters. Combine numbers,
                            special characters, upper and lowercase letters.
                          </p>
                        </>
                      )}
                    </>
                  )}
                </Form.Item>
              </div>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                  disabled={btnDisable}
                >
                  Update {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default ChangeAccountPassword;
